import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { /*useFreecodeContext,*/ useAppContext } from 'hooks/useContext';
import DropdownButton from 'components/Dropdown/DropdownButton';

export default function PublishButton() {
  // const { test } = useFreecodeContext();
  const { isDarkMode } = useAppContext();

  const [state, setState] = useState({ custom: true, archived: false });

  const [dropdownState, setDropdownState] = useState({ currentOption: { label: '' }, options: [] });

  useEffect(() => {
    let newDropdownState = {
      currentOption: { label: 'Publish' },
      options: [{ label: 'Publish' }, { label: 'Un-Publish' }, { label: 'Archive' }, { label: 'Un-Archive' }],
    };
    const filterPublishOptions = (display, disabledOptions) => {
      newDropdownState.currentOption = { label: display };
      newDropdownState.options = newDropdownState.options.filter((option) => !disabledOptions.includes(option.label));
    };
    if (!state.custom && !state.archived) {
      filterPublishOptions('Archive', ['Publish', 'Un-Archive']);
    } else if (state.archived) {
      filterPublishOptions('Publish', ['Archive', 'Un-Publish']);
    } else if (state.custom) {
      filterPublishOptions('Publish', ['Un-Archive', 'Un-Publish']);
    }
    setDropdownState((oldState) => ({ ...oldState, ...newDropdownState }));
  }, [state]);

  const handlePublishStatus = (option) => {
    let action = option.label;
    let newState = {};
    switch (action) {
      case 'Publish':
        newState.custom = false;
        newState.archived = false;
        break;
      case 'Archive':
        newState.custom = false;
        newState.archived = true;
        break;
      case 'Un-Publish': // fall-through
      case 'Un-Archive':
        newState.custom = true;
        newState.archived = false;
        break;
      default:
    }
    // TODO save and use real data
    toast.error('Publish status update not implemented');
    setState(newState);
  };

  return (
    <DropdownButton
      leftDrop={true}
      title="Handle the publish status of the test"
      isDarkMode={isDarkMode}
      value={dropdownState.currentOption}
      options={dropdownState.options}
      handleClick={handlePublishStatus}
    />
  );
}
